"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_dom_1 = require("react-dom");
var usePortal_1 = require("./usePortal");
/**
 * @example
 * <Portal>
 *   <p>Product</p>
 * </Portal>
 */
var Portal = function (_a) {
    var id = _a.id, children = _a.children;
    var target = (0, usePortal_1.default)(id);
    return (0, react_dom_1.createPortal)(children, target);
};
exports.default = Portal;
